import { delay } from 'redux-saga'
import { call, put, takeEvery } from 'redux-saga/effects'

// action types
export const SET_LOADING = 'rp/loading/SET_LOADING'
const SET_LOADING_SUCCESS = 'rp/loading/SET_LOADING_SUCCESS'
export const UNSET_LOADING = 'rp/loading/UNSET_LOADING'

export default function loading(state = {}, { payload, type }) {
  switch (type) {
    case SET_LOADING: {
      const { key, ...rest } = payload
      const extras = rest.successMessage ? { success: false } : {}
      return {
        ...state,
        [key]: { ...rest, ...extras },
      }
    }
    case SET_LOADING_SUCCESS:
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          success: true,
        },
      }
    case UNSET_LOADING:
      return Object.keys(state).reduce((obj, key) => {
        if (key === payload.key) return obj
        return { ...obj, [key]: state[key] }
      }, {})
    default:
      return state
  }
}

// action creators
// payload = { key: string, message: string }
export const setLoading = payload => ({
  type: SET_LOADING,
  payload,
})

// payload = { key: string }
export const setLoadingSuccess = (payload, originalAction = {}) => ({
  type: SET_LOADING_SUCCESS,
  originalAction,
  payload,
})

// payload = { key: string }
export const unsetLoading = payload => ({
  type: UNSET_LOADING,
  payload,
})

function* setSuccessTimer({ payload, originalAction: { callback } }) {
  // changing the code to handle success loader for modals
  if (payload.key === 'modal') {
    if (typeof callback === 'function') {
      yield delay(500)
      yield call(callback)
    }
    yield delay(1500)
    yield put(unsetLoading(payload))
  } else {
    yield delay(1500)
    yield put(unsetLoading(payload))
    if (typeof callback === 'function') yield call(callback)
  }
}

function* watchSetLoadingSuccess() {
  yield takeEvery(SET_LOADING_SUCCESS, setSuccessTimer)
}

export const sagas = [watchSetLoadingSuccess]
